import UseSetterNodeValue from "./UseSetterNodeValue";

const UseBlurHandler = (currentNode, tabName, fieldName, value, onBlur) => {
    onBlur(UseSetterNodeValue(currentNode, tabName, fieldName, value))
}

export default UseBlurHandler